import * as Colors from 'material-ui/styles/colors';

export default {
  container: {
    float: 'left'
  },
  toggleMenu: {
    textTransform: 'none',
    fontSize: '15px',
    padding: 0,
    height: '80px',
    paddingTop: '10px',
    paddingBottom: '5px'
  },
  toggleMenuHelpText: {
    fontSize: '12px',
    paddingTop: '5px',
    width: '200px',
    whiteSpace: 'normal',
    lineHeight: 'normal',
    paddingLeft: '56px',
    color: Colors.grey600
  },
  radioMenuItemStyle: {
    cursor: 'pointer',
    textTransform: 'none',
    fontSize: '15px',
    padding: '0',
    fontColor: Colors.grey800,
    height: '48px',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    ':hover': {
      backgroundColor: Colors.grey300
    }
  },
  radioButtonStyle: {
    height: '24px',
    width: '24px',
    paddingLeft: '20px',
    paddingRight: '8px'
  },
  menuIconStyle: {
    paddingRight: '12px'
  }
};
